import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Header from "./Nav/header";
import Container from "./container";
import FooterMobile from "./Footer/FooterMobile";
import "./layout.scss";
import Footer from "./Footer/Footer";
import { useEffect } from "react";
import AppProvider from "../../context/AppProvider";
import { AppContext } from "../../context/AppContext";
import { getAllCategories } from "../../services/Categories/getAllCateogories";

const Layout = ({ children }) => {
  const { country } = useContext(AppContext);
  const paises = [
    {
      id: 1,
      name: "Argentina",
    },
    {
      id: 5,
      name: "Bolivia",
    },
    {
      id: 3,
      name: "Chile",
    },
    {
      id: 4,
      name: "Paraguay",
    },
    {
      id: 2,
      name: "Uruguay",
    },
  ];

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const [isDropDownOpen, setDropDownOpen] = useState(false);

  const checkMobile = () => window.innerWidth <= 768;

  const blur = isDropDownOpen === true ? "yes" : "no";

  const openAndClose = () => {
    setDropDownOpen(!isDropDownOpen);
  };

  const [categories, setCategories] = useState([]);


  useEffect(() => {
    getAllCategories(country)
      .then((receivedCategories) => {
        if (receivedCategories && receivedCategories.length > 0) {
          setCategories(receivedCategories);
        } else {
          console.log("No se recibieron categorías");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [country]);

  const patternCategory = categories?.filter(
    (categories) => categories.patternCategory === null
  );

  const childCategory = categories?.filter(
    (categories) => categories.patternCategory !== null
  );

  useEffect(() => {
    const updateBodyStyle = () => {
      if (isDropDownOpen && checkMobile()) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    };

    updateBodyStyle();

    window.addEventListener("resize", updateBodyStyle);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("resize", updateBodyStyle);
    };
  }, [isDropDownOpen]);
  return (
    <AppProvider>
      <Header
        siteTitle={data.site.siteMetadata.title}
        openAndClose={openAndClose}
        isDropDownOpen={isDropDownOpen}
        paises={paises}
        categories={categories}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
      <div className={blur === "yes" ? "blur-effect" : ""}>
        <Container>{children}</Container>
      </div>

      <Footer
        paises={paises}
        categories={categories}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
      <FooterMobile
        paises={paises}
        patternCategory={patternCategory}
        childCategory={childCategory}
      />
    </AppProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
